import { Trans, useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  completeProfileButtonStyles,
  completeProfileButtonTextStyles,
  containerStyles,
  headerTextStyles,
  textStyles
} from '@/components/Discovery/Card/placeholders/styles.ts';
import { useProfileStore } from '@/store/useProfileStore.ts';
import { routes } from '@/navigation/routes.tsx';
import { AvatarWithProgressBar } from '@/components/Profile/Header/AvatarWithProgressBar/AvatarWithProgressBar.tsx';
import FallingStarShape from '@/components/common/svg/shapes/FallingStarShape.tsx';
import SmallStarsShape from '@/components/common/svg/shapes/SmallStarsShape.tsx';
import { helpers } from '@/helpers.ts';

export const CompleteProfile = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    setIsSkipCompleteProfilePlaceholder,
    getProfileCompletionPercentage,
    aboutMe
  } = useProfileStore();
  const profileCompletion = getProfileCompletionPercentage();

  const handleCompleteProfileButtonClick = useCallback(() => {
    navigate(routes.profileEdit);
  }, [navigate]);

  const handleSkipButtonClick = useCallback(() => {
    setIsSkipCompleteProfilePlaceholder(true);
  }, [setIsSkipCompleteProfilePlaceholder]);

  return (
    <div style={containerStyles}>
      <div
        style={{
          position: 'relative',
          width: 'fit-content',
          marginTop: '20px'
        }}
      >
        <div
          style={{
            width: 164,
            height: 164,
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.03)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              width: 136,
              height: 136,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.09)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <AvatarWithProgressBar
              profilePhoto={helpers.getPrimaryPhoto(
                aboutMe?.profile.v2photos?.[0]?.variants ?? []
              )}
              thumbhash={helpers.getThumbHash(
                aboutMe?.profile.v2photos?.[0]?.variants ?? []
              )}
              gender={aboutMe?.profile?.gender}
              profileCompletion={profileCompletion}
              strokeWidth={8}
              avatarSize={102}
              containerStyle={{ marginBottom: 0, boxShadow: 'none' }}
            />
          </div>
        </div>
        <div style={{ position: 'absolute', top: -15, left: -35 }}>
          <FallingStarShape height={40} width={40} />
        </div>
        <div style={{ position: 'absolute', bottom: 0, right: 0 }}>
          <SmallStarsShape height={30} width={30} />
        </div>
      </div>

      <div
        style={{
          ...headerTextStyles,
          marginTop: 5,
          fontSize: 21,
          fontWeight: 'bold'
        }}
      >
        <Trans
          i18nKey="discovery.card.placeholder.completeProfile.header"
          components={{ br: <br /> }}
        />
      </div>
      <p
        style={{
          ...textStyles,
          marginTop: 5,
          color: '#fff',
          fontWeight: 500,
          lineHeight: 1.5,
          fontSize: 14
        }}
      >
        <Trans
          i18nKey="discovery.card.placeholder.completeProfile.text"
          components={{ br: <br /> }}
        />
      </p>
      <motion.div
        onClick={handleCompleteProfileButtonClick}
        style={completeProfileButtonStyles}
        whileTap={{ scale: 0.95 }}
      >
        <span style={completeProfileButtonTextStyles}>
          {t('discovery.card.placeholder.completeProfile.button')}
        </span>
      </motion.div>
      <div
        style={{
          marginTop: 10,
          color: '#ffffff',
          opacity: 0.8,
          fontSize: 14,
          fontWeight: 'bold'
        }}
        onClick={handleSkipButtonClick}
      >
        <p>{t('discovery.card.placeholder.completeProfile.skip_button')}</p>
      </div>
    </div>
  );
};